let baseURL = "https://owner-api.teslamotors.com";
let client_id = "81527cff06843c8634fdc09e8ac0abefb46ac849f38fe1e431c2ef2106796384";
let client_secret = "c7257eb71a564034f9419ee651c7d0e5f7aa6bfbd18bafb5c5c033b093bb2fa3";


////////////////////////////////////////////////////////////////////////////////
// 토큰정보를 설정한다.
////////////////////////////////////////////////////////////////////////////////
export const SET_TOKEN = ( params ) => {
	return new Promise( ( resolve, reject ) => {
    if( params.token_type != "" && params.access_token != ""  ){
      token_type = params.token_type;
      access_token = params.access_token;
      resolve( "토큰 설정 완료" );
    }
    else{
      reject( new Error("인증 토큰 정보 오류") );
    }
  });
};


////////////////////////////////////////////////////////////////////////////////
// 로컬에 저장된 토큰정보를 리턴한다.
////////////////////////////////////////////////////////////////////////////////
export const GET_TOKEN = ( params ) => {
	return new Promise( ( resolve, reject ) => {
    if( token_type != "" && access_token != ""  ){
      resolve( {
        'token_type' : token_type,
        'access_token' : access_token
      });
    }
    else{
      reject( new Error("저장된 인증정보가 없습니다") );
    }
  });
};
////////////////////////////////////////////////////////////////////////////////
// 로그인
////////////////////////////////////////////////////////////////////////////////
export const LOGIN = ( params ) => {
  return new Promise( ( resolve, reject ) => {
    fetch( baseURL + "/oauth/token", {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        cache: "no-cache",
        'Cache-Control': 'no-cache'
      },
      body: JSON.stringify({
        grant_type    : "password",
        client_id     : client_id,
        client_secret : client_secret,
        email         : params.email,
        password      : params.password,
      })
    })
    .then( ( r ) => r.json())
    .then( ( response ) => {
      console.log(response);
      resolve({ "token_type":response.token_type, "access_token":response.access_token  });
    }).catch( ( error ) => {
      reject( new Error( error ) );
    });
  });
};

////////////////////////////////////////////////////////////////////////////////
// 계정에 등록된 차량정보를 요청
////////////////////////////////////////////////////////////////////////////////
export const GET_VEHICLES = () => {
  return new Promise((resolve, reject) => {
    fetch( baseURL + "/api/1/vehicles", {
      headers: { 
        Authorization : token_type + " " + access_token,
        cache: "no-cache",
        'Cache-Control': 'no-cache'
      }
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      var tmpArr = [];
      var i;
      var count = data.response.length;
      for( i = 0; i < count; i++  ){
        //로딩구분값과 차량 상세정보를 넣기위한 값을 넣어 사용
        tmpArr.push ( 
          Object.assign( { 
            loading : true, 
            lastUpdate : "",
            charge_state : {},
            climate_state: {},
            drive_state : {},
            gui_settings : {},
            vehicle_config : {},
            vehicle_state : {}
          }, 
          data.response[i] ) 
        );
      }
      resolve(tmpArr);
    }).catch(error => {
      reject( new Error( error ) );
    });
  });
};

////////////////////////////////////////////////////////////////////////////////
// 특정 차량정보를 요청
////////////////////////////////////////////////////////////////////////////////
export const GET_VEHICLE_STATE = ( VEHICLE ) => {
  console.log("차량상세조회를 시작합니다. Tesla.js");
  // console.log(VEHICLE);
  console.log("token_type : " + token_type);
  console.log("access_token : " + access_token);
  console.log( baseURL + "/api/1/vehicles/" + VEHICLE.id_s + "/vehicle_data");
  console.log("id_s : " + VEHICLE.id_s);
  console.log("id_state : " + VEHICLE.state);

  return new Promise( (resolve, reject ) => {
    if( VEHICLE.id_s == undefined ){
      reject( new Error("차량 상태 아이디 정보가 없습니다.") );
      return;
    }
    fetch( baseURL + "/api/1/vehicles/" + VEHICLE.id_s + "/vehicle_data", {
      headers: { 
        Authorization : token_type + " " + access_token,
        cache: "no-cache",
        'Cache-Control': 'no-cache'
      }
    }).then( ( res ) => {
      return res.json();
    }).then( ( data ) => {
      resolve(data.response);
    }).catch( ( error ) => {
      reject( new Error("차량 상태 조회를 실패했습니다.") );
    });
  });
};


////////////////////////////////////////////////////////////////////////////////
// 차량을 깨움
////////////////////////////////////////////////////////////////////////////////
export const SET_WEKE_UP = ( VEHICLE ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/" + VEHICLE.id_s + "/wake_up", {
      method: "POST",
      headers: { 
        Authorization : token_type + " " + access_token,
        cache: "no-cache",
        'Cache-Control': 'no-cache'
      }
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch(( error ) => {
      reject( new Error("차량 깨우기 요청 실패") );
    });
  });
};


////////////////////////////////////////////////////////////////////////////////
// 근처 충전소 찾기
////////////////////////////////////////////////////////////////////////////////
export const GET_NEARBY_CHARGING_SITES = ( VEHICLE ) => {
  console.log(VEHICLE.id_s);
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/" + VEHICLE.id_s + "/nearby_charging_sites", {
      method: "GET",
      headers: { 
        Authorization : token_type + " " + access_token,
        cache: "no-cache",
        'Cache-Control': 'no-cache'
      }
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data );
    }).catch(( error ) => {
      reject( new Error("근처 충전소 정보 요청 실패") );
    });
  });
};


////////////////////////////////////////////////////////////////////////////////
// 차량 문 열기
////////////////////////////////////////////////////////////////////////////////
export const SET_DOOR_UNLOCK = ( VEHICLE ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/"+ VEHICLE.id_s +"/command/door_unlock", {
      method: "POST",
      headers: { 
        Authorization : token_type + " " + access_token,
        cache: "no-cache",
        'Cache-Control': 'no-cache'
      }
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("차량 문열기 실패") );
    });
  });
};


////////////////////////////////////////////////////////////////////////////////
// 차량 문 잠금
////////////////////////////////////////////////////////////////////////////////
export const SET_DOOR_LOCK = ( VEHICLE ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/"+ VEHICLE.id_s +"/command/door_lock", {
      method: "POST",
      headers: { 
        Authorization : token_type + " " + access_token,
        cache: "no-cache",
        'Cache-Control': 'no-cache'
      }
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("차량 문잠금 실패") );
    });
  });
};


/*************************************************************************************************************************************************/
// 충전포트 열기
/*************************************************************************************************************************************************/
export const SET_CHART_PORT_DOOR_OPEN = ( VEHICLE ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/"+ VEHICLE.id_s +"/command/charge_port_door_open", {
      method: "POST",
      headers: { 
        Authorization : token_type + " " + access_token,
        cache: "no-cache",
        'Cache-Control': 'no-cache'
      }
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("충천포트 열기 실패") );
    });
  });
};

/*************************************************************************************************************************************************/
// 충전포트 닫기
/*************************************************************************************************************************************************/
export const SET_CHART_PORT_DOOR_CLOSE = ( VEHICLE ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/"+ VEHICLE.id_s +"/command/charge_port_door_close", {
      method: "POST",
      headers: { 
        Authorization : token_type + " " + access_token,
        cache: "no-cache",
        'Cache-Control': 'no-cache'
      }
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("충천포트 열기 실패") );
    });
  });
};


/*************************************************************************************************************************************************/
// 윈도우 열기
/*************************************************************************************************************************************************/
export const SET_WINDOW_CONTROL_VENT = ( VEHICLE ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/"+ VEHICLE.id_s +"/command/window_control", {
      method: "POST",
      headers: { 
        'Content-Type' : 'application/json',
        Authorization : token_type + " " + access_token,
        cache: "no-cache",
        'Cache-Control': 'no-cache'
      },
      body: JSON.stringify({
        command: "vent",
        lat : 0,
        lon : 0
      })
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("윈도우 열기 실패") );
    });
  });
};
      

/*************************************************************************************************************************************************/
// 윈도우 닫기
/*************************************************************************************************************************************************/
export const SET_WINDOW_CONTROL_CLOSE = ( VEHICLE ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/"+ VEHICLE.id_s +"/command/window_control", {
      method: "POST",
      headers: { 
        'Content-Type' : 'application/json',
        Authorization : token_type + " " + access_token,
        cache: "no-cache",
        'Cache-Control': 'no-cache'
      },
      body: JSON.stringify({
        command: "close",
        lat : 0,
        lon : 0
      })
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("윈도우 닫기 실패") );
    });
  });
};


/*************************************************************************************************************************************************/
// 자동 온도조절 켜기
/*************************************************************************************************************************************************/
export const SET_AUTO_CONDITIONING_START = ( VEHICLE ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/"+ VEHICLE.id_s +"/command/auto_conditioning_start", {
      method: "POST",
      headers: { 
        Authorization : token_type + " " + access_token,
        cache: "no-cache",
        'Cache-Control': 'no-cache'
      }
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("자동 온도 조절 켜기 실패") );
    });
  });
};

/*************************************************************************************************************************************************/
// 자동 온도조절 끄기
/*************************************************************************************************************************************************/
export const SET_AUTO_CONDITIONING_STOP= ( VEHICLE ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/"+ VEHICLE.id_s +"/command/auto_conditioning_stop", {
      method: "POST",
      headers: { 
        Authorization : token_type + " " + access_token,
        cache: "no-cache",
        'Cache-Control': 'no-cache'
      }
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("자동 온도 조절 끄기 실패") );
    });
  });
};


/*************************************************************************************************************************************************/
// 라이트켜기
/*************************************************************************************************************************************************/
export const SET_FLASH_LIGHT= ( VEHICLE ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/"+ VEHICLE.id_s +"/command/flash_lights", {
      method: "POST",
      headers: {  Authorization : token_type + " " + access_token,
      cache: "no-cache",
      'Cache-Control': 'no-cache' 
      }
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("라이트 점등 실패") );
    });
  });
};

/*************************************************************************************************************************************************/
// 경적울리기
/*************************************************************************************************************************************************/
export const SET_HONK_HORN = ( VEHICLE ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/"+ VEHICLE.id_s +"/command/honk_horn", {
      method: "POST",
      headers: {  Authorization : token_type + " " + access_token,
      cache: "no-cache",
      'Cache-Control': 'no-cache' 
      }
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("경적울리기 실패") );
    });
  });
};

/*************************************************************************************************************************************************/
// 트렁크열기
/*************************************************************************************************************************************************/
export const SET_ACTUATE_TRUNK_REAR = ( VEHICLE ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/" + VEHICLE.id_s + "/command/actuate_trunk", {
      method: "POST",
      headers: { 
        'Content-Type' : 'application/json',
        Authorization : token_type + " " + access_token
      },
      body: JSON.stringify({
        which_trunk: "rear"
      })
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("트렁크 열기 실패") );
    });
  });
};
  

/*************************************************************************************************************************************************/
// 프렁크열기
/*************************************************************************************************************************************************/
export const SET_ACTUATE_TRUNK_FRONT = ( VEHICLE ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/" + VEHICLE.id_s + "/command/actuate_trunk", {
      method: "POST",
      headers: { 
        'Content-Type' : 'application/json',
        Authorization : token_type + " " + access_token
      },
      body: JSON.stringify({
        which_trunk: "front"
      })
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("프렁크 열기 실패") );
    });
  });
};

/*************************************************************************************************************************************************/
// 온도 설정
/*************************************************************************************************************************************************/
export const SET_TEMPS = ( VEHICLE, data ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/" + VEHICLE.id_s + "/command/set_temps", {
      method: "POST",
      headers: { 
        'Content-Type' : 'application/json',
        Authorization : token_type + " " + access_token
      },
      body: JSON.stringify({
        driver_temp : data.driver_temp,
        passenger_temp : data.passenger_temp
      })
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("온도 설정 실패") );
    });
  });
};


/*************************************************************************************************************************************************/
// 자동온도 조절 시작 설정
/*************************************************************************************************************************************************/
export const SET_CONDITIONING_START = ( VEHICLE, data ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/" + VEHICLE.id_s + "/command/auto_conditioning_start", {
      method: "POST",
      headers: { 
        'Content-Type' : 'application/json',
        Authorization : token_type + " " + access_token
      }
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("자동 온도 설정 시작 실패") );
    });
  });
};


/*************************************************************************************************************************************************/
// 자동온도 조절 끝 설정
/*************************************************************************************************************************************************/
export const SET_CONDITIONING_STOP = ( VEHICLE, data ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/" + VEHICLE.id_s + "/command/auto_conditioning_stop", {
      method: "POST",
      headers: { 
        'Content-Type' : 'application/json',
        Authorization : token_type + " " + access_token
      }
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("자동 온도 설정 시작 실패") );
    });
  });
};


/*************************************************************************************************************************************************/
// 최대 충전량 설정
/*************************************************************************************************************************************************/
export const SET_CHARGE_LIMIT = ( VEHICLE, data ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/" + VEHICLE.id_s + "/command/set_charge_limit", {
      method: "POST",
      headers: { 
        'Content-Type' : 'application/json',
        Authorization : token_type + " " + access_token
      },
      body: JSON.stringify({
        percent : data.percent
      })
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("최대 충전량 설정 실패") );
    });
  });
};


/*************************************************************************************************************************************************/
// 최대 충전량 기본으로 설정
/*************************************************************************************************************************************************/
export const SET_CHARGE_STANDARD = ( VEHICLE, data ) => {
  return new Promise( (resolve, reject ) => {
    fetch( baseURL + "/api/1/vehicles/" + VEHICLE.id_s + "/command/charge_standard", {
      method: "POST",
      headers: { 
        'Content-Type' : 'application/json',
        Authorization : token_type + " " + access_token
      }
    }).then((res)=>{
      return res.json();
    }).then((data)=>{
      resolve( data.response );
    }).catch((error ) => {
      reject( new Error("최대 충전량 기본설정 실패") );
    });
  });
};



// WEBPACK FOOTER //
// ./src/tesla/index.js